<div class="wrap">
  <div class="wrap__header">
    <app-topbar></app-topbar>
  </div>

  <div class="wrap__content">
    <app-loader *ngIf="authLoading"></app-loader>
    <!--        <div *ngIf="!authLoading" [@routeAnimations]="prepareRoute(outlet)">-->
    <!--            <router-outlet #outlet="outlet"></router-outlet>-->
    <!--        </div>-->
    <div *ngIf="!authLoading">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="wrap__footer">
    <app-footer></app-footer>
  </div>

  <div class="scroll-to-top__ctrl color-gray" *ngIf="isShow" (click)="gotoTop()">
    <app-icon [glyph]="'arrow-top'" [size]="'16'"></app-icon>
  </div>
</div>
